/**
 * Everything about how the site presents itself, in one place.
 *
 * **The project has two names, on purpose.** *Freehouse* is the public one —
 * the site, the domain, what a player calls it. *CardEngine* stays the
 * technical one: the repo, the npm scopes (`@cardengine/*`), the Docker image,
 * the server paths. Nothing user-facing should spell CardEngine out, and
 * nothing internal needs renaming to Freehouse.
 *
 * That split is why this file exists. The name was isolated here from the
 * start so settling on a domain would be a one-line change, and it was: the
 * nav bar, page titles, home page, footer and meta description all read from
 * these values rather than repeating them.
 *
 * A freehouse is a pub tied to no brewery — which is the whole idea. No
 * accounts, no gatekeeping, pull up a chair.
 */
export const SITE = {
    name: 'Freehouse',
    /** Canonical origin, for absolute URLs the browser cannot infer (sitemap). */
    url: 'https://freehouse.games',
    /** Shown under the name on the home page. */
    tagline: 'Pull up a chair.',
    /**
     * One-liner for the home page and the HTML meta description.
     *
     * Said "Card games" until the catalogue stopped being only cards. It sits
     * directly above the shelves on the home page, so the moment one of those
     * shelves held a game with no deck in it the line was contradicting the page
     * underneath it.
     */
    blurb: 'Card and paper games with friends or AI. No accounts — pick a name, share a code, play.',
};
/** Builds the browser tab title for a page. */
export function pageTitle(section) {
    return section ? `${section} — ${SITE.name}` : `${SITE.name} — ${SITE.tagline}`;
}
//# sourceMappingURL=brand.js.map